/**
 * AAA IDP content reducer
 * 
 */

import { CONTENT } from '../../actions/types';
import { SITE_CONTENT } from './Site.content';
const initialState = SITE_CONTENT;
export default function (state = initialState, action) {
  switch (action.type) {
    case CONTENT:
      return action.value;
    default:
      return state;
  }
}